import React, { useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'

import {
  AutenticacaoContainer,
  Cores,
  ErroLayoutContainer,
  FormUnform,
  IconeDocumento,
  IconeEditar,
  IconeErrado,
  IconeInformacao,
  IconePagamentoMatricula,
  IconeRevelarSenha,
  Modal,
  ModalRef,
  SelectUnform,
  Spacer,
  Tabela,
  TabelaDados,
  TabelaRef,
  TabelaResposta,
  Tooltip
} from 'src/componentes'
import { FuncoesDataHora } from 'src/componentes/funcoes'
import { RotasAluno } from 'src/rotas/aluno'
import { RotasRescisaoAluno } from 'src/rotas/rescisao'
import { Api } from 'src/servicos'
import {
  CategoriaTicketPorExtenso,
  StatusRescisao,
  StatusRescisaoPorExtenso,
  TipoOrdenacao
} from 'src/tipos'

import { COLUNAS_REQUERIMENTOS } from './colunas'
import { StatusPorExtenso } from './colunas/situacao'
import {
  ModalRealizarDownload,
  ModalRealizarDownloadRef
} from './modal-realizar-download'
import {
  TituloPrincipal,
  ContainerDaPagina,
  SubMenu,
  ContainerAcoes,
  IconeAcao,
  CampoFiltro,
  FiltroStatus,
  SecaoTabela,
  TextoSelect,
  ContainerRequerimentos,
  RequerimentoDisponivel,
  ComponenteDetalhesRequerimentos,
  ContainerInformacoes,
  ContainerInformacoesObservacao
} from './style'

export const OPCOES_STATUS = [
  {
    id: 'cancelado',
    texto: 'Cancelado'
  },
  {
    id: 'concluido',
    texto: 'Concluído'
  },
  {
    id: 'emAndamento',
    texto: 'Em Andamento'
  },
  {
    id: 'solicitado',
    texto: 'Solicitado'
  },
  {
    id: 'aberto',
    texto: 'Aberto'
  },
  {
    id: null,
    texto: 'Todos'
  }
]

/** Tipo fixo — hoje só existe um tipo de requerimento. */
const TIPO_REQUERIMENTO_CERTIFICADO = 'SolicitacaoCertificadoImpresso'

export const PaginaRequerimentosAluno: React.FC = () => {
  const history = useHistory()
  const tabelaRef = useRef<TabelaRef>()
  const tabelaRescisaoRef = useRef<TabelaRef>()
  const [paginas, definirPaginas] = useState<number>(null)
  const [filtroStatus, definirFiltroStatus] = useState<string>()
  const [totalRequerimentos, definirTotalRequerimentos] = useState<number>()
  const [totalPedidosRescisao, definirTotalPedidosRescisao] = useState<number>()
  const modalDetalhamentoRef = useRef<ModalRef>(null)
  const modalObservacaoRef = useRef<ModalRef>(null)
  const modalDeCancelamentoRequerimentoRef = useRef<ModalRef>(null)
  const modalRealizarDownloadRef = useRef<ModalRealizarDownloadRef>(null)
  const [observacao, definirrObservacao] = useState()
  const tipoRequerimento = TIPO_REQUERIMENTO_CERTIFICADO
  const { usuario } = AutenticacaoContainer.useContainer()
  const [requerimentoId, defirRequerimentoId] = useState()

  const obterDados = async (
    numeroPaginas: number,
    quantidadePorPagina: number,
    chaveOrdenacao?: string,
    ordem?: TipoOrdenacao
  ): Promise<TabelaResposta | null> => {
    if (paginas !== null) {
      numeroPaginas = paginas
    }
    const dados = await Api.ObterRequerimentos(
      TIPO_REQUERIMENTO_CERTIFICADO,
      filtroStatus,
      numeroPaginas,
      quantidadePorPagina,
      chaveOrdenacao,
      ordem
    )

    if (!dados) return null

    definirPaginas(null)
    definirTotalRequerimentos(dados?.itens?.length ?? 0)

    return {
      Dados: dados?.itens
    } as TabelaResposta
  }

  const obterDadosRescisao = async (): Promise<TabelaResposta | null> => {
    const pedidos = await Api.ListarMeusPedidosRescisao()

    definirTotalPedidosRescisao(pedidos.length)

    return { Dados: pedidos } as TabelaResposta
  }

  const cancelarRequerimento = async (id: string) => {
    try {
      await Api.CancelarRequerimentoAluno(id)
      toast('Requerimento cancelado!', { type: 'success' })
      tabelaRef.current.CarregarDados()
    } catch (error) {}

    modalDeCancelamentoRequerimentoRef?.current?.fechar()
  }

  useEffect(() => {
    tabelaRef.current.CarregarDados()
  }, [filtroStatus])

  return (
    <ContainerDaPagina>
      <TituloPrincipal>Requerimentos</TituloPrincipal>
      <Spacer padding="10px 0px" />

      <ContainerInformacoes>
        <p>Olá {usuario.nome}! Tudo bem?</p>
        <p>
          Neste espaço você pode realizar solicitações gerais de forma rápida e
          fácil.
        </p>
        <p>
          Se precisar falar com a gente sobre outros assuntos, nos contate no
          (51) 3062-9322 (WhatsApp ou Ligação).
        </p>
        <p>Equipe Faculdade iPGS.</p>
      </ContainerInformacoes>
      <Spacer padding="10px 0px" />

      <SubMenu>Requerimentos Disponíveis</SubMenu>
      <ContainerRequerimentos>
        {/* <RequerimentoDisponivel>
          <div
            data-tip={'Solicitar Ementa de Disciplina'}
            data-for={'icone-requerimento-detalhes'}
            onClick={() => history.push(RotasAluno.EmentaDisciplina)}
          >
            <span>{'>'}</span>
            <p>Ementa de Disciplinas</p>
            <Tooltip
              id={'icone-requerimento-detalhes'}
              textColor={Cores.PRETO}
              backgroundColor={Cores.CINZA_1_CLARO}
              place="top"
            />
          </div>
          <ComponenteDetalhesRequerimentos
            onClick={() => modalDetalhamentoRef?.current?.abrir()}
          >
            <p>+ Detalhes</p>
          </ComponenteDetalhesRequerimentos>
        </RequerimentoDisponivel> */}
        <RequerimentoDisponivel>
          <div
            data-tip={'Solicitar Certificado Impresso'}
            data-for={'icone-requerimento-detalhes'}
            onClick={() => history.push(RotasAluno.CertificadoImpresso)}
          >
            <span>{'>'}</span>
            <p>Certificado Impresso</p>
            <Tooltip
              id={'icone-requerimento-detalhes'}
              textColor={Cores.PRETO}
              backgroundColor={Cores.CINZA_1_CLARO}
              place="top"
            />
          </div>
          <ComponenteDetalhesRequerimentos
            onClick={() => modalDetalhamentoRef?.current?.abrir()}
          >
            <p>+ Detalhes</p>
          </ComponenteDetalhesRequerimentos>
        </RequerimentoDisponivel>
        <SecaoTabela oculto={totalRequerimentos === 0 && !filtroStatus}>
          <Spacer padding="10px 0px" />
          <SubMenu>Solicitação de Certificado Impresso</SubMenu>
          <FormUnform acaoSucesso={() => null}>
            <FiltroStatus>
              <TextoSelect>Status</TextoSelect>
              <CampoFiltro>
                <SelectUnform
                  margemInferior={false}
                  id="slct_status"
                  name="status"
                  opcoes={OPCOES_STATUS}
                  valorAlterado={e => definirFiltroStatus(e?.id)}
                />
              </CampoFiltro>
            </FiltroStatus>
          </FormUnform>

          <Tabela
            ref={tabelaRef}
          Colunas={[
            ...COLUNAS_REQUERIMENTOS,
            {
              Chave: 'acoes',
              Alinhamento: 'center',
              Renderizar: (linha: TabelaDados) => {
                return (
                  <ContainerAcoes>
                    <IconeAcao
                      onClick={() => {
                        history.push(
                          `${RotasAluno.DetalhesRequerimento}/${linha.id}`
                        )
                      }}
                      disabled={linha?.observacao?.length < 1}
                      data-tip={
                        linha?.observacao?.length < 1
                          ? 'Não há detalhes sobre este requerimento.'
                          : 'Visualizar Detalhes'
                      }
                      data-for={'icone-visualizar-detalhes'}
                    >
                      {IconeInformacao}
                      <Tooltip
                        id={'icone-visualizar-detalhes'}
                        textColor={Cores.PRETO}
                        backgroundColor={Cores.CINZA_1_CLARO}
                        place="bottom"
                      />
                    </IconeAcao>
                    {linha?.situacao === StatusPorExtenso.Aberto && (
                      <IconeAcao
                        onClick={() => {
                          history.push(
                            `${RotasAluno.CertificadoImpressoPagamento}/${linha.matriculaId}`
                          )
                        }}
                        disabled={linha?.observacao?.length < 1}
                        data-tip={'Realizar Pagamento'}
                        data-for={'icone-realizar-pagamento'}
                      >
                        {IconePagamentoMatricula}
                        <Tooltip
                          id={'icone-realizar-pagamento'}
                          textColor={Cores.PRETO}
                          backgroundColor={Cores.CINZA_1_CLARO}
                          place="bottom"
                        />
                      </IconeAcao>
                    )}
                    {linha?.tipoRequerimento ===
                      'SolicitacaoCertificadoImpresso' && (
                      <IconeAcao
                        data-tip={'Visualizar Documentos'}
                        data-for={'icone-Visualizar-Documentos'}
                        onClick={() =>
                          modalRealizarDownloadRef?.current?.abrir(linha?.id)
                        }
                      >
                        {IconeRevelarSenha}
                        <Tooltip
                          id={'icone-Visualizar-Documentos'}
                          textColor={Cores.PRETO}
                          backgroundColor={Cores.CINZA_1_CLARO}
                          place="bottom"
                        />
                      </IconeAcao>
                    )}
                    <IconeAcao
                      onClick={() => {
                        if (
                          linha?.situacao === 'Solicitado' ||
                          linha?.situacao === 'Aberto'
                        ) {
                          defirRequerimentoId(linha?.id)
                          modalDeCancelamentoRequerimentoRef?.current?.abrir()
                        }
                      }}
                      data-tip={
                        linha?.situacao !== 'Solicitado' &&
                        linha?.situacao !== 'Aberto'
                          ? 'O requerimento não pode ser cancelado.'
                          : 'Cancelar'
                      }
                      data-for={'icone-cancelar'}
                      disabled={
                        linha?.situacao !== 'Solicitado' &&
                        linha?.situacao !== 'Aberto'
                      }
                    >
                      {IconeErrado}
                      <Tooltip
                        id={'icone-cancelar'}
                        textColor={Cores.PRETO}
                        backgroundColor={Cores.CINZA_1_CLARO}
                        place="bottom"
                      />
                    </IconeAcao>
                  </ContainerAcoes>
                )
              },
              RenderizarCabecalho: () => (
                <div style={{ width: 120, paddingRight: '20px' }}>Ações</div>
              )
            }
          ]}
          ObterDados={obterDados}
        />
          <Spacer padding="10px 0px" />
        </SecaoTabela>

        <SecaoTabela oculto={totalPedidosRescisao === 0}>
          <SubMenu>Pedidos de Rescisão</SubMenu>

          <Tabela
            ref={tabelaRescisaoRef}
          Colunas={[
            {
              Chave: 'numeroProtocolo',
              Alinhamento: 'center',
              Renderizar: (linha: TabelaDados) => <>{linha.numeroProtocolo}</>,
              RenderizarCabecalho: () => <div style={{ width: 110 }}>Protocolo</div>
            },
            {
              Chave: 'curso',
              Alinhamento: 'center',
              Renderizar: (linha: TabelaDados) => <>{linha.curso ?? '—'}</>,
              RenderizarCabecalho: () => (
                <div style={{ width: 180 }}>Turma/Curso</div>
              )
            },
            {
              Chave: 'dataAbertura',
              Alinhamento: 'center',
              Renderizar: (linha: TabelaDados) => (
                <>
                  {linha.dataAbertura
                    ? FuncoesDataHora.dataStringFormatadaComBarras(
                        linha.dataAbertura
                      )
                    : '—'}
                </>
              ),
              RenderizarCabecalho: () => (
                <div style={{ width: 120 }}>Data Abertura</div>
              )
            },
            {
              Chave: 'dataFimProtocolo',
              Alinhamento: 'center',
              Renderizar: (linha: TabelaDados) => (
                <>
                  {linha.dataFimProtocolo
                    ? FuncoesDataHora.dataStringFormatadaComBarras(
                        linha.dataFimProtocolo
                      )
                    : '—'}
                </>
              ),
              RenderizarCabecalho: () => <div style={{ width: 100 }}>Data Fim</div>
            },
            {
              Chave: 'motivo',
              Alinhamento: 'center',
              Renderizar: (linha: TabelaDados) => <>{linha.motivo ?? '—'}</>,
              RenderizarCabecalho: () => <div style={{ width: 160 }}>Motivo</div>
            },
            {
              Chave: 'status',
              Alinhamento: 'center',
              Renderizar: (linha: TabelaDados) => (
                <>
                  {StatusRescisaoPorExtenso[
                    linha.status as keyof typeof StatusRescisao
                  ] ?? linha.status}
                </>
              ),
              RenderizarCabecalho: () => <div style={{ width: 140 }}>Status</div>
            },
            {
              Chave: 'acoesRescisao',
              Alinhamento: 'center',
              Renderizar: (linha: TabelaDados) => (
                <ContainerAcoes>
                  {(linha.status === StatusRescisao.EmAberto ||
                    linha.status ===
                      StatusRescisao.AguardandoRespostaFormulario) && (
                    <IconeAcao
                      onClick={() =>
                        history.push(
                          `${RotasRescisaoAluno.Wizard}/${linha.id}`
                        )
                      }
                      data-tip={'Continuar solicitação'}
                      data-for={'icone-continuar-rescisao'}
                    >
                      {IconeEditar}
                      <Tooltip
                        id={'icone-continuar-rescisao'}
                        textColor={Cores.PRETO}
                        backgroundColor={Cores.CINZA_1_CLARO}
                        place="bottom"
                      />
                    </IconeAcao>
                  )}
                  {linha.status === StatusRescisao.AguardandoTermoRescisao && (
                    <IconeAcao
                      onClick={() =>
                        history.push(`${RotasRescisaoAluno.Termo}/${linha.id}`)
                      }
                      data-tip={'Ver termo de rescisão'}
                      data-for={'icone-termo-rescisao'}
                    >
                      {IconeDocumento}
                      <Tooltip
                        id={'icone-termo-rescisao'}
                        textColor={Cores.PRETO}
                        backgroundColor={Cores.CINZA_1_CLARO}
                        place="bottom"
                      />
                    </IconeAcao>
                  )}
                </ContainerAcoes>
              ),
              RenderizarCabecalho: () => (
                <div style={{ width: 100, paddingRight: '20px' }}>Ações</div>
              )
            }
          ]}
          ObterDados={obterDadosRescisao}
        />
          <Spacer padding="10px 0px" />
        </SecaoTabela>
      </ContainerRequerimentos>
      <Modal
        ref={modalDetalhamentoRef}
        backdrop
        id="modal-de-cancelamento"
        titulo="Solicitação de Certificado Impresso"
        acaoPrimaria={{
          titulo: 'Fechar',
          tipo: 'button',
          acao: () => modalDetalhamentoRef?.current?.fechar()
        }}
      >
        <ContainerInformacoes>
          <p>
            Aqui você realiza a solicitação de seu Certificado de Conclusão de
            Curso no formato físico, ou seja, enviaremos o seu certificado
            impresso para o endereço solicitado.
          </p>
          <p>
            O prazo para atendimento da sua solicitação é de até 30 dias para
            envio, tendo em vista o tempo de deslocamento.
          </p>
          <p>
            Lembre de inserir o endereço completo, com CEP, e ter alguém no
            local para receber o documento.
          </p>
          <p>
            Ressaltamos que esta solicitação tem o custo de R$ 150,00, com
            pagamento via Pix, cartão de crédito ou boleto.
          </p>
        </ContainerInformacoes>
      </Modal>
      <Modal
        ref={modalObservacaoRef}
        backdrop
        id="modal-detalhes-atendimento"
        titulo="Detalhes do Atendimento"
        acaoPrimaria={{
          titulo: 'Fechar',
          tipo: 'button',
          acao: () => modalObservacaoRef?.current?.fechar()
        }}
      >
        <ContainerInformacoesObservacao>
          <p>Solicitação: {CategoriaTicketPorExtenso[tipoRequerimento]}</p>
          <p
            style={{
              border: `1px solid ${Cores.CINZA_1_CLARO}`,
              padding: '5px'
            }}
          >
            {observacao}
          </p>
        </ContainerInformacoesObservacao>
      </Modal>
      <Modal
        ref={modalDeCancelamentoRequerimentoRef}
        backdrop
        id="modal-de-cancelamento"
        titulo="Deseja cancelar?"
        acaoPrimaria={{
          titulo: 'Sim',
          tipo: 'button',
          acao: () => cancelarRequerimento(requerimentoId)
        }}
        acaoSecundario={{
          titulo: 'Não',
          tipo: 'button',
          acao: () => modalDeCancelamentoRequerimentoRef?.current?.fechar()
        }}
      >
        <p>Selecione uma opção</p>
      </Modal>
      <ModalRealizarDownload
        ref={modalRealizarDownloadRef}
        backdrop
        id="modal-realizar-download"
      />
    </ContainerDaPagina>
  )
}

export default (): JSX.Element => (
  <ErroLayoutContainer.Provider>
    <PaginaRequerimentosAluno />
  </ErroLayoutContainer.Provider>
)
